module.exports = __webpack_public_path__ + "img/product-icon_4.0217e609.png";